import request from '@/utils/request'

const url = '/auth-service/chapters'

export function page(params) {
  return request({
    url: `${url}/page`,
    method: 'get',
    params: params
  })
}

export function view(id) {
  return request({
    url: `${url}/${id}`,
    method: 'get',
    params: {}
  })
}

export function create(params) {
  return request({
    url: `${url}`,
    method: 'post',
    params: params
  })
}

export function update(params) {
  return request({
    url: `${url}/${params.id}`,
    method: 'put',
    params: params
  })
}

export function remove(id) {
  return request({
    url: `${url}/${id}`,
    method: 'delete'
  })
}

export function published(params) {
  return request({
    url: `${url}/published/${params.id}/${params.enabled}`,
    method: 'post'
  })
}
// parentId, chapterIds
export function reorder(params) {
  return request({
    url: `${url}/reorder`,
    method: 'post',
    params: params
  })
}
